import React from 'react'

import { Skeleton } from '@fourthwall/components'
import { formatSubscriptionBytes } from '@modules/Dashboard/modules/Subscriptions'

import * as S from './StorageLimit.styled'

type StorageLimitProps = {
  title: string
  currentSize: number
  maxSize: number
  isLoading: boolean
}

export const StorageLimit = ({ title, currentSize, maxSize, isLoading }: StorageLimitProps) => {
  const completionPercentage = (currentSize / maxSize) * 100
  const isUnlimited = maxSize === -1
  const isFull = isUnlimited ? false : currentSize >= maxSize

  if (isLoading) return <StorageLimitSkeleton />

  return (
    <S.Container>
      <S.Header>
        <S.Title>{title}</S.Title>
        <S.Limit isFull={isFull}>
          {formatSubscriptionBytes(currentSize)}
          {!isUnlimited && ` of ${formatSubscriptionBytes(maxSize)} used`}
        </S.Limit>
      </S.Header>
      {!isUnlimited && <S.Bar isFull={isFull} completionPercentage={completionPercentage} />}
    </S.Container>
  )
}

export const StorageLimitSkeleton = () => {
  return (
    <S.Container>
      <S.Header>
        <Skeleton.Shape width={170} height={24} />
        <S.Limit>
          <Skeleton.Shape width={170} height={24} />
        </S.Limit>
      </S.Header>
      <Skeleton.Shape width="100%" height={10} />
    </S.Container>
  )
}

StorageLimit.Skeleton = StorageLimitSkeleton
